import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

const apiAuthBaseUrl = `${environment.futBaseAdminopUrl}userlogin`;
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const expired = auth.hasExpiredSession();

  if (expired) {
    auth.logout({ redirectToLogin: true, reason: 'session-expired' });
    return EMPTY;
  }

  const token = auth.accessToken();

  if (
    !token
    || request.url === apiAuthBaseUrl
  ) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    })
  );
};
